import { render, staticRenderFns } from "./CourseUserDialog.vue?vue&type=template&id=7fb45320&scoped=true&lang=pug"
import script from "./CourseUserDialog.vue?vue&type=script&lang=js"
export * from "./CourseUserDialog.vue?vue&type=script&lang=js"
import style0 from "./CourseUserDialog.vue?vue&type=style&index=0&id=7fb45320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb45320",
  null
  
)

export default component.exports